{
  "footer": {
    "alreadyPartner": "Jau esate partneris?",
    "back": "Atgal",
    "letsgo": "Pirmyn!",
    "login": "Prisijungti",
    "next": "Kitas",
    "readMore": "Sužinok daugiau",
    "signUp": "Registruotis"
  },
  "formErrors": {
    "address": "Šio adreso nepavyksta rasti. Įveskite egzistuojantį adresą.",
    "businessName": "Šis pavadinimas negalimas. Prašome pasirinkti kitą",
    "email": "Šis el. pašto adresas jau naudojamas",
    "verificationCode": "Kodas neteisingas"
  },
  "global": {
    "title": "Prisijunk prie Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Įmonės pavadinimas per ilgas",
      "label": "Salono/paskyros pavadinimas",
      "required": "Būtina"
    },
    "businessSegment": {
      "aesthetics": "Grožio salonas",
      "barber": "Barber",
      "beautician": "Kosmetologija",
      "hair-removal": "Depiliacija",
      "hairdresser": "Kirpykla",
      "massage": "Masažas",
      "nails": "Nagai",
      "primary": "Pagrindinis",
      "required": "Pasirink bent vieną",
      "spa": "SPA centras"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Galiu patvirtinti, kad turiu specialų atskirą kambarį bei reikalingus dokumentus veiklai vykdyti",
      "home": "Įsikūrę namuose <0>- klientai atvyksta į namus.</0>",
      "mobile": "Mobilus <0>- vykstate į klientų namus.</0>",
      "mobileCheckbox": "Noriu naudoti tik \"Treatwell\" kalendorių be prekyvietės.",
      "mobileMessage": "Deja, dėl tam tikrų apribojimų, paskyrą galime sukurti paskyrą tik  turint nuolatinį adresą.",
      "required": "Pasirink vieną",
      "shop": "Salonas <0>- paslaugos teikiamos salone</0>"
    },
    "city": {
      "invalid": "Miestas per ilgas",
      "label": "Miestas",
      "required": "Būtina"
    },
    "country": {
      "label": "Šalis",
      "required": "Būtina"
    },
    "email": {
      "invalid": "Neteisingas",
      "label": "El. paštas",
      "required": "Būtina"
    },
    "firstName": {
      "invalid": "Neteisingas vardas",
      "label": "Vardas",
      "required": "Būtina"
    },
    "lastName": {
      "invalid": "Neteisinga pavardė",
      "label": "Pavardė",
      "required": "Būtina"
    },
    "marketing": {
      "label": "Norėčiau gauti pranešimus el. paštu, kad galėčiau plėsti savo verslą ir gauti ekspertų patarimų."
    },
    "password": {
      "hint": "Ne mažiau kaip 8 simboliai",
      "invalid": "Slaptažodis turi turėti bent 8 simbolius",
      "label": "Slaptažodis",
      "required": "Būtina"
    },
    "phoneNumber": {
      "invalid": "Neteisingas telefono numeris",
      "label": "Telefono numeris",
      "required": "Būtina"
    },
    "postalCode": {
      "invalid": "Pašto kodas per ilgas",
      "label": "Pašto kodas",
      "required": "Būtina"
    },
    "privacy": {
      "label": "Registruodamiesi nemokamai paskyrai sutinkate su mūsų <0>privatumo politika</0> ir mūsų <1>svetainėje</1> išdėstytomis taisyklėmis ir sąlygomis."
    },
    "searchBusiness": {
      "label": "Salono paieška"
    },
    "street": {
      "invalid": "Adresas per ilgas",
      "label": "Adresas",
      "required": "Būtina"
    }
  },
  "salesMode": {
    "enterPassword": "Įveskite pardavimo režimo slaptažodį",
    "invalidPassword": "Neteisingas slaptažodis"
  },
  "stepContext": {
    "attractNewClients": "Pritraukite naujų klientų",
    "buildRelationships": "Kurkite dar geresnius santykius su savo klientais",
    "growBusiness": "Gražiai auginkite savo verslą",
    "manageAppointments": "Valdykite visus savo susitikimus kelionėje",
    "prompt": "Esi tik keli žingsniai nuo prisijungimo prie Treatwell - daugiau nei 75 000 salonų bendruomenės, kurie valdo savo verslą, plečia klientų bazę ir didina savo pajamas.<br /><br />Su Treatwell galėsi:",
    "prompt2": "...ir dar daugiau",
    "title": "<0>Prisijungti prie Treatwell</0> – didžiausios plaukų ir grožio salonų platformos Europoje – niekada nebuvo taip paprasta."
  },
  "stepCounter": {
    "step0": "0 žingsnis",
    "step1": "1 žingsnis",
    "step2": "2 žingsnis",
    "step3": "3 žingsnis",
    "step4": "4 žingsnis",
    "step5": "Sveikiname"
  },
  "stepEmailVerification": {
    "resend": "Atsiųsti kodą iš naujo",
    "subTitle1": "Tiesiog įrašyk gautą kodą savo registracijai užbaigti.",
    "subTitle2": "Negavai kodo?",
    "title": "<0>Jau beveik viskas -</0> el. paštu išsiuntėme tau 6 simbolių patvirtinimo kodą!"
  },
  "stepError": {
    "accountCreation": "Paskyra kuriama",
    "body": "Susidūrėme su problemomis.\nPrašome šiek tiek palaukti ir pabandyti dar kartą.",
    "bodyWithError": "Susidūrėme su problemomis, susijusiomis su {{reason}}.\nPrašome palaukti minutę ir pabandyti dar karta.",
    "button": "Bandyti iš naujo",
    "title": "Oops, kažkas nepavyko!"
  },
  "stepFinal": {
    "joke1Punchline": "Ne, mes tik kerpame plaukus!",
    "joke1Setup": "Ar čia darote stebuklus?",
    "joke2Punchline": "Šampano!",
    "joke2Setup": "Sveiki, kavos, arbatos ar vandens?",
    "joke3Punchline": "Su terapija ar be?",
    "joke3Setup": "Kokia bus manikiūro kaina?",
    "joke4Punchline": "Pasitikėti savimi!",
    "joke4Setup": "Kaip atrodyti puikiai?",
    "joke5Punchline": "",
    "joke5Setup": "",
    "subTitle": "Kad laukimas neprailgtų, paskaitykite…",
    "title": "Ačiū, sukurkime tavo paskyrą!!<br />Duok mums <0>pora minučių...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Prisijunk",
    "alternativeMessage": "Ar vedi jau naudojamą  adresą naujai paskyrai registruoti?",
    "button": "Treatwell Prisijungimas",
    "message": "<0>Puikios naujienos!</0> Tavo paskyra jau sukurta!"
  },
  "stepFourForm": {
    "prompt1": "Naudosime šią informaciją, kad sukurtume tavo paskyrą ir, jei prireiktų, susisieksime.",
    "title": "Papasakok apie save"
  },
  "stepOneForm": {
    "prompt1": "Ieškok arba įvesk savo salono pavadinimą",
    "title": "Papasakok apie save"
  },
  "stepOneSearch": {
    "addManually": "Nerandi savo adreso? <0>Pridėk jį rankiniu būdu</0>",
    "prompt1": "Ieškok arba įvesk savo saloną",
    "title": "Papasakok apie save"
  },
  "stepThreeForm": {
    "title": "Kokio tipo verslą vykdote?"
  },
  "stepTwoForm": {
    "prompt1": "Pasirink visus tinkamus variantus, pagrindines paslaugas pridėk pirmiau ",
    "title": "Kokias paslaugas atliekate?"
  }
}